import React from 'react';
import { Logger } from '../../utils';
import QualityPicker from './quality-picker.jsx';
import SettingsMenu from './settings-menu.jsx';
import RatePicker from './rate-picker.jsx';

const logger = Logger.getInstance('player');

export default class SettingsCog extends React.Component {
  constructor() {
    super();
    this.state = {
      menuVisible: false,
      submenu: null,
    };
  }

  render() {
    const { showQualitySelector, showRateSelector, forceMenuClose, isHD, is4K } = this.props;
    if (showQualitySelector || showRateSelector) {
      return (
        <div
          onKeyDown={(e) => this.handleKeyDown(e)}
          onBlur={(e) => this.handleBlur(e)}
        >
          <button
            type="button"
            ref={(el) => { this.cogButton = el; }}
            className="boxcast-clappr-button"
            data-playback-rate-button
            tabIndex={0}
            aria-label="Player Settings (Quality, Speed, CC)"
            aria-expanded={this.state.menuVisible}
            onClick={() => this.toggleMenu()}
          >
            <i className="boxcast-icon-cog"></i>
            {is4K ? <span className="boxcast-cog-4k">4K</span> : (isHD ? <span className="boxcast-cog-hd">HD</span> : '')}
          </button>
          {this.state.menuVisible ? this.renderMenu() : <span />}
        </div>
      );
    } else {
      return <span />;
    }
  }

  static getDerivedStateFromProps(newProps, state) {
    if (newProps.forceMenuClose && state.menuVisible) {
      newProps.onToggleMenuVisibility(false);
      return { menuVisible: false };
    }
    return null;
  }

  onChangeRate(newRate) {
    if (this.props.onChangeRate) {
      this.props.onChangeRate(newRate);
    }
    this.closeMenu();
    requestAnimationFrame(() => { if (this.cogButton) this.cogButton.focus(); });
  }

  onChangeLevel(newLevel) {
    if (this.props.onChangeLevel) {
      this.props.onChangeLevel(newLevel);
    }
    this.closeMenu();
    requestAnimationFrame(() => { if (this.cogButton) this.cogButton.focus(); });
  }

  renderMenu() {
    if (this.state.submenu == 'quality') {
      return (
        <QualityPicker
          onBack={() => this.setState({ submenu: null })}
          onChangeLevel={(newLevel) => this.onChangeLevel(newLevel)}
          currentLevel={this.props.currentLevel}
          nextLevelIndex={this.props.nextLevelIndex}
          levels={this.props.levels}
        />
      );
    } else if (this.state.submenu == 'speed') {
      return (
        <RatePicker
          onBack={() => this.setState({ submenu: null })}
          onChangeRate={(newRate) => this.onChangeRate(newRate)}
          currentRate={this.props.currentRate}
          rates={this.props.rates}
        />
      );
    } else {
      return (
        <SettingsMenu onChangeMenu={(menu) => this.setState({ submenu: menu })} {...this.props} />
      );
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Escape' && this.state.menuVisible) {
      e.stopPropagation();
      this.closeMenu();
      if (this.cogButton) this.cogButton.focus();
    }
  }

  handleBlur(e) {
    if (!this.state.menuVisible) return;
    // relatedTarget is the element receiving focus.
    if (!e.relatedTarget) return;

    var wrapper = e.currentTarget;
    // don't close the menu if the element to be focused is contained in this element (or vice-versa)
    if (wrapper.contains(e.relatedTarget) || e.relatedTarget.contains(wrapper)) return;

    this.closeMenu();
  }

  closeMenu() {
    this.setState({ menuVisible: false, submenu: null });
    this.props.onToggleMenuVisibility(false);
  }

  toggleMenu() {
    var currentlyOpen = this.state.menuVisible;
    this.setState({
      menuVisible: !currentlyOpen,
      submenu: null, //always start at the root menu
    });
    this.props.onToggleMenuVisibility(!currentlyOpen);
  }
}
